import { Injectable } from '@angular/core';
import { ApiService } from '../centrui/src/app/services/api.service';
import { BannerNotification } from '../common/models/BannerNotification';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../centrui/src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationBannerService {

  public notificationBanner!: BannerNotification;
  public notificationBannerSubject = new BehaviorSubject<BannerNotification>(this.notificationBanner);

  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) { }

  getBanner() {
    this.apiService.get(BannerNotification).subscribe((response: any) => {
      const banners = (response as BannerNotification[]).filter(banner => banner.is_active); 
      if (banners.length > 0) {
        this.setBanner(banners[0]);
      }
    });
  }

  setBanner(banner: BannerNotification) {
    this.notificationBanner = banner;
    this.notificationBannerSubject.next(banner);
  }
  
  getBannerValid() {
    if(!this.notificationBanner) return false;
    if(!this.authService.userObject && (this.notificationBanner.type === 'auth')) {
      return false;
    }
    if(this.authService.userObject && (this.notificationBanner.type === 'no-auth')) {
      return false;
    }
    const bannerNotification = localStorage.getItem('bannerNotification' + this.notificationBanner.id);
    if(!bannerNotification) return true;
    const notification = JSON.parse(bannerNotification);
    if (notification.closed || notification.expiry < Date.now()) {
      return false;
    }
    return true;
  } 
  
}
